<div mat-dialog-title class="title">
    <span class="heading">Manage Roles</span>
    <button mat-dialog-close class="close-button" mat-icon-button matSuffix>
        <mat-icon class="close-icon-color">cancel</mat-icon>
    </button>
</div>
<div mat-dialog-content>
    <form [formGroup]="managerRolesForm" (ngSubmit)="onSubmit()">
        <table mat-table [dataSource]="dataSource" formArrayName="roles">
            <ng-container matColumnDef="roleId">
                <th mat-header-cell *matHeaderCellDef> Role ID</th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    {{element.roleId}}
                </td>
            </ng-container>

            <ng-container matColumnDef="actionstepRole">
                <th mat-header-cell *matHeaderCellDef> Actionstep Roles </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    {{element.actionstepRole}}
                </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Description</th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    {{element.description}}
                </td>
            </ng-container>

            <ng-container matColumnDef="request">
                <th mat-header-cell *matHeaderCellDef> Request </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <mat-checkbox formControlName="request"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="partnerApprove">
                <th mat-header-cell *matHeaderCellDef> Partner Approve </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <mat-checkbox formControlName="partnerApprove"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="accountsApprove">
                <th mat-header-cell *matHeaderCellDef> Accounts Approve </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <mat-checkbox formControlName="accountsApprove"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="viewAuditLog">
                <th mat-header-cell *matHeaderCellDef> View Audit Log </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <mat-checkbox formControlName="viewAuditLog"></mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="manageRoles">
                <th mat-header-cell *matHeaderCellDef> Manage Roles </th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
                    <mat-checkbox formControlName="manageRoles"></mat-checkbox>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="manageRolesDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: manageRolesDisplayedColumns;"></tr>
        </table>
    </form>
</div>

<div mat-dialog-actions class="action-buttons">
    <button mat-raised-button (click)="onSubmit()" color="accent" type="submit" [disabled]="!managerRolesForm.dirty">
        Save
    </button>
</div>
